import { Link } from 'react-router-dom';

const tools = [
  { icon: 'ri-task-line', text: 'Развивающие задачи за пределами текущих обязанностей' },
  { icon: 'ri-user-heart-line', text: 'Наставничество со стороны опытных руководителей' },
  { icon: 'ri-group-line', text: 'Участие в проектах, где сотрудник пробует новые роли' },
  { icon: 'ri-expand-up-down-line', text: 'Расширение ответственности постепенно, а не резко' },
  { icon: 'ri-vip-crown-line', text: 'Обучение управленческим компетенциям' },
  { icon: 'ri-chat-check-line', text: 'Регулярная обратная связь по развитию' },
  { icon: 'ri-time-line', text: 'Временное выполнение части функций будущей роли' },
  { icon: 'ri-radar-line', text: 'Оценка готовности к новой роли' },
];

export default function TalentPool() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие и кадровый резерв
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Кадровый резерв — это не просто список перспективных сотрудников. Чтобы резерв работал, необходимо создавать условия для их развития.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {tools.map((t, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${t.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8 text-center">
          <p className="text-base text-gray-700 leading-relaxed mb-5 max-w-2xl mx-auto">
            Подготовка будущих руководителей тесно связана с развитием управленческих компетенций. Методы, подходы и программы для руководителей собраны в кластере «Менеджмент и лидерство».
          </p>
          <Link
            to="/menedzhment-i-liderstvo"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
          >
            Кластер «Менеджмент и лидерство»
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}